import _ from 'lodash';
import { createApp, defineComponent } from 'vue';
import GridCustomColumnEditor from './GridCustomColumnEditor.vue';
import userCustomColumns from '../../../controllers/userCustomColumns';
import constants from '$$helpers/constants/';
import globalToast from '$$vueCmp/toast';
import KeyboardNavigation from '../../keyboardNavigation';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridCustomColumnEditor);

      const options = instance.config.columns.find(col => col.control_id === column.control_id).control_options;
      const dateToStr = instance.date.date_to_str;
      const onSave = () => {
        instance.ext.inlineEditors.save();
      };
      const onCancel = () => {
        instance.ext.inlineEditors.hide();
      };

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder, {
        placeholder,
        column,
        options,
        dateToStr,
        onSave,
        onCancel
      });
      vueInstance = vueApp.mount(placeholder);

      if (column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id) {
        KeyboardNavigation.toggleState(false);
      }
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;

      if (vueInstance.column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id) {
        KeyboardNavigation.toggleState(true);
      }

      vueInstance = null;
    },

    set_value(task, id, column, node) {
      vueInstance.value = userCustomColumns.getUserCustomValue(task, column.name).value;
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(task, id, column, node) {
      if (
        column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id
        && userCustomColumns.getUserCustomValue(task, column.name).value === vueInstance.value?.valueOf()
      ) {
        return false
      }

      return true;
    },

    is_valid(value, id, column, node) {
      if (column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id) {
        if (value === '') return true;

        if (!(value instanceof Date) || (value instanceof Date && isNaN(value.getTime()))) {
          globalToast.warning(__('gantt_date_invalid'));

          return false;
        }
      }

      return true;
    },

    save(id, column, node) {
      const task = instance.getTask(id);
      const type = column.data_type.split('_')[1];

      const oldValue = userCustomColumns.getUserCustomValue(task, column.name).value;
      const value = vueInstance.value;

      if (_.isDate(oldValue) && _.isDate(value)) {
        if (value.getTime() !== oldValue.getTime()) {
          instance.ganttDataApi.changeUserCustomValue(task, column.name, value);

          userExtAnalytics.log('task_grid_action', { action: 'custom_field', type });
        }

        return;
      }

      if (!(!value && !oldValue) && (value !== oldValue)) {
        instance.ganttDataApi.changeUserCustomValue(task, column.id, value);

        userExtAnalytics.log('task_grid_action', { action: 'custom_field', type });
      }
    },

    focus(node) {
    },
  };
}
